import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import "./PaymentDetails.scss";
import Button from "../Buttons/Button";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInterceptor";
import stripe from "../../Assets/logo/stripe.png";
import razorpay from "../../Assets/logo/razorpay.png";

const PaymentDetails = ({ questionData, fetchData, disable = false }) => {
  const [open, setOpen] = useState("1");
  const [questionDetails, setQuestionDetails] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    setQuestionDetails(questionData);
  }, [questionData]);

  const [setting, setSetting] = useState([]);
  const flatdiscontent = async () => {
    try {
      const res = await axiosInstance.get(`/admin/setting/getSetting`);
      setSetting(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    flatdiscontent();
  }, []);

  useEffect(() => {
    if (questionDetails?.studentPaymentStatus === "Paid") {
      navigate("/dashboard/order-history");
    }
  }, [questionDetails?.studentPaymentStatus, navigate, questionDetails]);

  const fetchPaymentSessionData = async (paymentMethod) => {
    if (
      questionDetails?.paymentId &&
      String(questionDetails.paymentId).startsWith("http")
    ) {
      window.location.href = questionDetails.paymentId;
      return;
    }

    navigate(`/checkout`, {
      state: {
        paymentMethod,
        questionDetails,
      },
    });
  };

  const handlePayment = (paymentMethod) => {
    fetchPaymentSessionData(paymentMethod);
  };

  const specialSubCategoryIds = [
    "6586dfe7d2f7eeadeea4fafa",
    "6586d9a9dafb1f4a8f461274",
  ];

  return (
    <>
      <Accordion
        open={open}
        toggle={(id) => setOpen(id === open ? "" : id)}
        className="req-accordion"
      >
        <AccordionItem
          className={
            disable && questionDetails?.estimatedPrice === 0 ? "disabled" : ""
          }
        >
          <AccordionHeader targetId="1" className="heading">
            {specialSubCategoryIds.includes(questionDetails?.subCategoryId?._id)
              ? "Payment (We are calculating the best price for you!)"
              : "Payment"}
          </AccordionHeader>

          {!disable || questionDetails?.estimatedPrice !== 0 ? (
            <>
              <AccordionBody accordionId="1">
                <div className="d-flex justify-content-between total-amount">
                  <span className="pe-3 greyTitle w-25 text-start">
                    Total Amount
                  </span>
                  {questionDetails?.estimatedPrice?.toFixed(2) && (
                    <span className="ps-3 w-25 text-end price">
                      {"$"}
                      {questionDetails?.estimatedPrice?.toFixed(2)}
                    </span>
                  )}
                </div>
                <div className="d-flex justify-content-between total-amount">
                  {questionDetails?.discountPrice > 0 ? (
                    <>
                      <span className="pe-3 greyTitle w-25 text-start">
                        Discounted Amount
                      </span>
                      {questionDetails?.discountPrice?.toFixed(2) && (
                        <span className="ps-3 w-25 text-end price">
                          {"$"}
                          {questionDetails?.discountPrice?.toFixed(2)}
                        </span>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="d-flex justify-content-start text-start flex-column gap-3">
                  <div className="w-100 w-md-80 d-flex flex-column">
                    {questionData.totalPrice?.toFixed(2) && (
                      <div className="finalAmount">
                        {"$"}
                        {questionData.totalPrice?.toFixed(2)}
                      </div>
                    )}
                    <div className="greyTitle">Payable Amount</div>
                  </div>

                  <div className="w-100 w-md-20 mt-1">
                    {setting.paymentMethod?.length === 2 && (
                      <div className="mt-2">Choose Payment Options</div>
                    )}
                    {setting.paymentMethod?.includes("Stripe") && (
                      <Button
                        className="payment-paypage"
                        text={
                          setting.paymentMethod?.length === 1 &&
                          setting.paymentMethod?.includes("Stripe") ? (
                            "Continue to Pay"
                          ) : (
                            <img
                              src={stripe}
                              alt="Stripe Logo"
                              className="stripe-logo"
                            />
                          )
                        }
                        varient={
                          setting.paymentMethod?.length === 1 &&
                          setting.paymentMethod?.includes("Stripe")
                            ? "linear-gradient-primary"
                            : undefined
                        }
                        onClick={() => handlePayment("Stripe")}
                        disabled={questionDetails?.estimatedPrice === 0}
                      />
                    )}

                    {setting.paymentMethod?.includes("Razorpay") && (
                      <Button
                        className="payment-paypage mx-2 p-0"
                        text={
                          setting.paymentMethod?.length === 1 &&
                          setting.paymentMethod?.includes("Razorpay") ? (
                            "Continue to Pay"
                          ) : (
                            <img
                              src={razorpay}
                              alt="Razorpay Logo"
                              className="razorpay-logo"
                            />
                          )
                        }
                        varient={
                          setting.paymentMethod?.length === 1 &&
                          setting.paymentMethod?.includes("Razorpay")
                            ? "linear-gradient-primary"
                            : undefined
                        }
                        onClick={() => handlePayment("Razorpay")}
                        disabled={questionDetails?.estimatedPrice === 0}
                      />
                    )}
                  </div>
                </div>
              </AccordionBody>
            </>
          ) : (
            <></>
          )}
        </AccordionItem>
      </Accordion>
    </>
  );
};

export default PaymentDetails;
